import Permissions from './permissions'

declare module 'vue/types/vue' {
  export interface Vue {
    $permissions: Permissions
  }
}

export default {
  install(Vue: any, options: any) {
    // Declare new permissions instance
    Vue.prototype.$permissions = new Permissions(options.store)
  },
}
